import React, { forwardRef, ReactElement } from 'react';
import { Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  tooltip: {
    fontSize: 14,
  },
}));

interface TooltipComponentProps {
  id?: string;
  title: string | ReactElement;
  children: ReactElement;
  disableHoverListener?: boolean;
  arrow?: boolean;
  classes?: object;
}

const TooltipComponent = forwardRef<HTMLDivElement, TooltipComponentProps>(
  ({ id = '', title, children, disableHoverListener = false, arrow = true, classes = {}, ...props }, ref) => {
    const defaultClasses = useStyles();

    return (
      <Tooltip
        ref={ref}
        id={id}
        title={title}
        disableHoverListener={disableHoverListener}
        classes={{ ...defaultClasses, ...classes }}
        arrow={arrow}
        {...props}
      >
        {children}
      </Tooltip>
    );
  },
);

TooltipComponent.displayName = 'TooltipComponent';

export default TooltipComponent;
